export default "__VITE_IMAGE_ASSET__91060e92__";